import {
  Description,
  RestrictedSections,
} from '@/creditflowresearch/ui/common/components/CreditFlowResearch/CreditFlowData';

import styles from './articles.module.scss';

const ArticleExpandedData = ({ rowData }) => (
  <>
    <Description
      description={ rowData.description }
      dataTest="articleDescription"
      className={ styles.expandedDescription }
    />
    <RestrictedSections
      sections={ rowData.sections }
      dataTest="articleRestrictedSections"
      className={ styles.expandedRestrictedSections }
    />
  </>
);

export default ArticleExpandedData;
